export const customizer_pages = [
    {
        label:'General Sections',
        value: 'general-sections'
    },
    {
        label:'Home Page',
        value:'homepage'
    },
    {
        label:'Photos Printing Delivery',
        value:'photo-print'
    },
    {
        label: 'Passport Size Photos',
        value: 'passport-size-photos'
    },
    {
        label: 'Documents Printing',
        value: 'documents-printing'
    },
    {
        label: 'Foam Board Panels',
        value: 'foam-board-panels'
    },
    {
        label: 'Stickers Printing',
        value: 'stickers-printing'
    },
    {
        label: 'Certificates Printing',
        value: 'certificates-printing'
    },
    {
        label: 'Canvas Printing',
        value: 'canvas-printing'
    },
    {
        label: 'Business Cards',
        value: 'business-cards'
    },
    {
        label: 'CV Templates',
        value: 'cv-templates'
    },
    {
        label: 'Logo Designing',
        value: 'logo-designing'
    },
    {
        label: 'Photo Retouching',
        value: 'photo-retouching'
    },
    {
        label: 'Caricatures',
        value: 'caricatures'
    },
    {
        label: 'Greeting Cards Printing',
        value: 'greeting-cards-printing'
    },
    {
        label: 'Mugs Printing',
        value: 'mugs-printing'
    },
    {
        label: 'TShirts Printing',
        value: 't-shirts-printing'
    },
    {
        label: 'Flyers Printing',
        value: 'flyers-printing'
    },
    {
        label: 'Menu Printing',
        value: 'menu-printing'
    },
    {
        label: 'Brochures Printing',
        value: 'brochures-printing'
    },
    {
        label: 'Pamphlets Printing',
        value: 'pamphlets-printing'
    },
    // {
    //     label: 'Portrait Headshots',
    //     value: 'portrait-headshots'
    // },
    // {
    //     label: 'Event Photography',
    //     value: 'event-photography'
    // },
    // {
    //     label: 'Wedding Photography',
    //     value: 'wedding-photography'
    // },
    // {
    //     label: 'Food Photography',
    //     value: 'food-photography'
    // },
    // {
    //     label: 'Product Photography',
    //     value: 'product-photography'
    // },
    {
        label: 'Passport Photo Requirements',
        value: 'passport-photo-requirements'
    },
    {
        label: 'Blog',
        value: 'blog'
    }
]

export const roles = [
    'admin', 
    'assistant_admin',
    'order_management_specialist',
    'order_management_associate',
    'delivery_associate',
    'e_commerce_admin',
    'content_manager'
]